import { render, staticRenderFns } from "./Franco.vue?vue&type=template&id=745b2d99&"
import script from "./Franco.vue?vue&type=script&lang=js&"
export * from "./Franco.vue?vue&type=script&lang=js&"
import style0 from "./Franco.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports